module.exports = __webpack_public_path__ + "static/img/task_appraise_1.43f3d001.png";